import React, { FC } from 'react'
import { useController } from 'react-hook-form'
import { Checkbox } from './checkbox'

interface FormCheckboxProps {
  name: string
  label: string
}

export const FormCheckbox: FC<FormCheckboxProps> = ({ name, label }) => {
  const {
    field: { onChange, value, ref },
    fieldState: { error }
  } = useController({ name })

  return (
    <Checkbox
      value={!!value}
      label={label}
      onChange={onChange}
      inputRef={ref}
      errorMessage={error?.message}
    />
  )
}
